module.exports = __webpack_public_path__ + "img/Closed Icon - white.4d4b059d.svg";